
interface PodPricingProps {
  pricePerMinute: string;
}

const PodPricing = ({ pricePerMinute }: PodPricingProps) => {
  const formatPrice = (pricePerMinute: string) => {
    const price = parseFloat(pricePerMinute);
    const pricePerHour = (price * 60).toFixed(2);
    const price30Min = (price * 30).toFixed(2);
    return {
      perMin: `£${price}/min`,
      perHour: `£${pricePerHour}/hour`,
      per30Min: `£${price30Min}/30min`
    };
  };

  const pricing = formatPrice(pricePerMinute);

  return (
    <div>
      <div className="font-medium text-xl">{pricing.perMin}</div>
      <div className="text-gray-500 text-sm mt-1">
        {pricing.perHour} • {pricing.per30Min}
      </div>
    </div>
  );
};

export default PodPricing;
